import VoyageService from "@/services/voyageService";

export default {
  async getLastPositionWithTimeout(_, coordinates) {
    try {
      const res = await VoyageService.getLastPositionWithTimeout(coordinates);
      return res.data;
    } catch (error) {
      return null;
    }
  },
  async resetGridMapState({ commit }) {
    let defaultState = {
      activeSidebarForGrid: { mapId: "", isActive: false, menuName: "" },
      allGridMapSettings: [],
      expiredPopupForGrid: null,
      lastTrackingPosition: { mapId: "", center: [] },
    };
    commit("RESET_STATE", defaultState);
  },
};
